<template>
  <div>
    <chart-line-statistics
      :chart-data="chartData"
      :options="options"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/types';

import ChartLineStatistics from './ChartLineStatistics';

export default {
  name: 'ChartStatisticsProcessTime',
  components: {
    ChartLineStatistics,
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          mode: 'x',
          bodySpacing: 10,
        },
        legend: {
          align: 'start',
          labels: {
            fontFamily: 'Inter',
            fontSize: 14,
            usePointStyle: true,
            padding: 30,
          },
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false,
              color: '#CCC8BC',
              lineWidth: 3,
              zeroLineWidth: 3,
              zeroLineColor: '#dadada',
              drawTicks: true,
              tickMarkLength: 3,
            },
            ticks: {
              fontFamily: 'Inter',
              fontSize: 14,
              fontColor: '#908F8D',
            },
          }],
          yAxes: [{
            gridLines: {
              display: true,
              color: '#CCC8BC',
              zeroLineColor: '#dadada',
              drawTicks: true,
              tickMarkLength: 3,
              borderDash: [3, 4],
            },
            ticks: {
              fontFamily: 'Inter',
              fontSize: 14,
              fontColor: '#908F8D',
            },
          }],
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      labels: types.STATISTICS_SERVICES_LABELS,
      therapistAverageData: types.STATISTICS_SERVICES_THERAPIST_AVERAGE_TAKE_ON_TIME,
      pediatricianAverageData: types.STATISTICS_SERVICES_PEDIATRICIAN_AVERAGE_TAKE_ON_TIME,
      specializedServiceData: types.STATISTICS_SERVICES_SPECIALIZED_AVERAGE_TAKE_ON_TIME,
    }),
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: 'Время ответа дежурного терапевта, мин',
            borderColor: '#F2994A',
            backgroundColor: '#F2994A',
            data: this.therapistAverageData,
            pointHitRadius: 10,
            lineTension: 0,
            fill: false,
          },
          {
            label: 'Время ответа дежурного педиатра, мин',
            backgroundColor: '#219653',
            borderColor: '#219653',
            data: this.pediatricianAverageData,
            pointHitRadius: 10,
            lineTension: 0,
            fill: false,
          },
          {
            label: 'Время ответа узких специалистов, мин',
            backgroundColor: '#9B51E0',
            borderColor: '#9B51E0',
            data: this.specializedServiceData,
            pointHitRadius: 10,
            lineTension: 0,
            fill: false,
          },
        ],
      };
    },
  },
};
</script>

<style lang='scss' scoped>

</style>
